import React from 'react';
import classNames from 'classnames';
import Const from '../../../config/const';
import classes from '../classes.module.scss';
import { SvgIcon } from '../../../../common/sprites';
import withPGTranslation from '../../../config/withPGTranslation';

interface PhoneNumberCtaProps {
  changeScreen: (screen: string) => void;
  t: (key: string) => string;
  loading?: boolean;
}

/**
 * PhoneNumberCta component - Button to navigate to phone entry screen
 */
function PhoneNumberCta({
  changeScreen,
  t,
  loading = false
}: PhoneNumberCtaProps) {
  const handleClick = (): void => {
    if (loading) return;
    changeScreen(Const.authScreens.phoneEntry);
  };

  return (
    <button
      type="button"
      className={ classNames(
        classes.phoneNumberCtaButton,
        loading ? classes.phoneNumberCtaButtonDisabled : null
      ) }
      onClick={ handleClick }
      disabled={ loading }
    >
      <SvgIcon
        id="phone_icon"
        size={ 24 }
        className={ classes.phoneNumberCtaIcon }
      />
      <span className={ classes.phoneNumberCtaText }>
        {t('smsVerification.continue_with_phone_number')}
      </span>
    </button>
  );
}

export default withPGTranslation(PhoneNumberCta);
